import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Dashboard from './Dashboard';
import Admin from './Admin';
import AdminLogin from './AdminLogin';
import Settings from './Settings';
import ProctorApp from './proctor/ProctorApp';
import './App.css';
import { AuthProvider } from './context/AuthContext';

// New Admin Components
import AdminLanding from './admin/AdminLanding';
import SkillsManager from './admin/skills/SkillsManager';
import StationTemplates from './admin/templates/StationTemplates';
import ProctorManager from './admin/proctors/ProctorManager';
import TestHistory from './admin/history/TestHistory';
import TestResultsView from './admin/history/TestResultsView';
import EditEvent from './admin/events/EditEvent';

function AppHeader() {
  const location = useLocation();
  if (location.pathname.startsWith('/proctor') ||
      location.pathname === '/' ||
      location.pathname === '/admin/login') {
    return null;
  }
  return (
    <div className="header-bar">
      <div className="header-brand">
        <svg className="header-flame" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M16 2C16 2 8 10 8 18C8 22.4 10.4 26.2 14 28.4C13.2 26.8 13 25 13.4 23.2C14.6 25 16.4 26.2 18 26C17 24 17.2 21.6 18.8 20C19.6 22 20.8 23.4 22 24C22 20 20 16.4 16 14C17.6 16.4 18 19.2 16.8 22C15.2 20 14.4 17.2 15.2 14.4C13.2 16.4 12 19.4 12.4 22.6C10.4 20.4 9.6 17.2 10.4 14C9.2 16 8.4 18.4 8.8 20.8C8.2 19.8 8 18.6 8 17.4C8 23.4 11.6 28.4 17 30C17.4 30.2 17.8 30.2 18.2 30.4C22.6 28.6 26 24.4 26 18C26 10 18 2 16 2Z" fill="#f97316"/>
          <path d="M16 6C16 6 10 13 10 19C10 22.4 11.8 25.4 14.6 27.2C14.2 25.8 14.2 24.2 14.8 22.8C15.8 24.4 17.2 25.4 18.6 25.2C17.8 23.4 18 21.2 19.4 19.8C20 21.6 21 22.8 22 23.4C22 19.8 20.2 16.6 17 14.8C18.4 16.8 18.6 19.2 17.6 21.6C16.2 19.8 15.6 17.4 16.2 15C14.4 16.8 13.4 19.4 13.8 22C12 20.2 11.4 17.4 12 15C11.2 16.8 10.6 18.8 11 21C10.6 20.2 10.4 19.2 10.4 18.2C10.4 23 13.6 27 18 28.4C21.6 26.8 24 23.2 24 19C24 13 18 6 16 6Z" fill="#122044"/>
        </svg>
        <div className="header-text">
          <span className="header-title">EVOLUTION</span>
          <span className="header-subtitle">Firefighter Skills Testing</span>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
      <AppHeader />
      <Routes>
        {/* Public/Proctor */}
        <Route path="/" element={<AdminLogin />} />
        <Route path="/proctor/*" element={<ProctorApp />} />
        {/* Admin Setup Layer */}
        <Route path="/admin" element={<AdminLanding />} />
        <Route path="/admin/dashboard" element={<AdminLanding />} /> {/* Alias */}
        <Route path="/admin/skills" element={<SkillsManager />} />
        <Route path="/admin/templates" element={<StationTemplates />} />
        <Route path="/admin/proctors" element={<ProctorManager />} />
        <Route path="/admin/history" element={<TestHistory />} />
        <Route path="/admin/history/:id" element={<TestResultsView />} />
        <Route path="/admin/events/:id/edit" element={<EditEvent />} />
        <Route path="/admin/settings" element={<Settings />} />
        {/* Admin Legacy/Core */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/manual-entry" element={<Admin />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/test-session/:sessionId" element={<Dashboard />} />
      </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
